import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getOrder, saveOrder } from '../services/orderService';
import { getMyDetails } from '../services/userService';
import moment from 'moment';
import Select from './Common/select';
import auth from '../services/authService';
import Loader from './loader';

class OrderPage extends Component {
  state = {
    currentUser: '',
    loading: true,
    order: [],
    user: '',
    cancelPopup: false,
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.props.updateDashboardMenu('orders');

    await this.populateOrderDetails();

    const currentUser = auth.getCurrentUser();
    this.setState({ currentUser, loading: false });
  }

  populateOrderDetails = async () => {
    try {
      const orderId = this.props.match.params.id;
      const { data: order } = await getOrder(orderId);
      this.setState({
        order: this.mapToViewOrder(order),
        cartItems: order.cartItems,
      });
      const { data: user } = await getMyDetails(order.userId);
      this.setState({
        user: this.mapToViewUser(user),
        
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace('/not-found');
    }
  };

  mapToViewOrder(order) {
    return {
      _id: order._id,
      userId: order.userId,
      name: order.name,
      useremail: order.useremail,
      profilePic: order.profilePic,
      address: order.address,
      city: order.city,
      country: order.country,
      postalCode: order.postalCode,
      phone: order.phone,
      paymentMethod: order.paymentMethod,
      cartItems: order.cartItems,
      orderStatus: order.orderStatus,
      publishDate: order.publishDate,
    };
  }

  mapToViewUser(user) {
    return {
      _id: user._id,
      name: user.name,
      email: user.email,
      phone: user.phone || '',
      password: user.password,
      profilePic: user.profilePic || '',
      address: user.address || '',
      city: user.city || '',
      country: user.country || '',
      postalCode: user.postalCode || '',
      //   theme: user.theme,
    };
  }

  handleChange = ({ currentTarget: input }) => {
    const order = { ...this.state.order };
    order[input.name] = input.value;

    this.setState({ order });
  };

  handleCancelPopUp = () => {
    let { cancelPopup } = this.state;
    cancelPopup = !cancelPopup;
    this.setState({ cancelPopup });
  };

  updateOrder = async (status) => {
    const { order } = this.state;

    if (status) {
      order['orderStatus'] = status;
    }

    console.log(order);
    try {
      await saveOrder(order);

      //   this.props.handleNotification({
      //     message: 'Order placed successfully!',
      //     img: '/img/success.png',
      //   });

      this.props.history.push('/dashboard/orders/');
    } catch (err) {
      console.log(err);
    }
  };

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  render() {
    const {
      order,
      user,
      cartItems,
      loading,
      currentUser,
      cancelPopup,
    } = this.state;
    let inc = 1.12;

    if (loading) return <Loader />;

    return (
      <div className='order-page'>
        <div className='row'>
          {cancelPopup && (
            <React.Fragment>
              <div
                className='delete-popup-background'
                onClick={this.handleCancelPopUp}
              ></div>
              <div className='delete-pop-up'>
                <h5>Are you sure to cancel this order?</h5>
                <div className='inner-pop'>
                  {/* <img src={deleteRequestedProduct.imageUrl} alt='pop' /> */}
                  <div className='inner-pop-text'>
                    {/* <h2>Order:id {order._id}</h2>
                    <h2>Total amount: {this.calculateTotal(cartItems)}</h2> */}
                  </div>
                </div>
                <button onClick={() => this.updateOrder('Cancelled')}>
                  Yes
                </button>
                <button onClick={this.handleCancelPopUp}>No</button>
              </div>
            </React.Fragment>
          )}

          <div className='col-md-12 p-2'>
            <div
              className='profile-right-block'
              style={{ animationDelay: '0.1s' }}
            >
              <br />

              <Link to='/dashboard/orders/'>
                <button className='back-btn'>
                  <i className='fas fa-angle-double-left'></i> Back
                </button>
              </Link>

              <div className='row ' style={{ width: '100%' }}>
                <div className='col-md-8 p-4 order-page-details'>
                  <p>
                    <b>Order id:</b> {order._id}
                  </p>
                  <p>
                    <b>Order placed:</b>{' '}
                    {moment(order.publishDate).format('lll')}
                  </p>
                  <p>
                    <b>Reciever name:</b> {order.name}
                  </p>
                  <p>
                    <b>Reciever address:</b> {order.address}, {order.city},{' '}
                    {order.country}
                  </p>
                  <p>
                    <b>City:</b> {order.city} {order.postalCode}
                  </p>
                  {!loading && (
                    <p>
                      <b>Payment method:</b>{' '}
                      {order.paymentMethod === 'cod' ? (
                        'Cash on delivery'
                      ) : (
                        <span>
                          {this.cardInfo(order.paymentMethod).type}
                          <span className='card-details'>
                            <img
                              src={this.cardInfo(order.paymentMethod).img}
                                alt='Type'
                                height='30px'
                              />
                              **** {this.cardInfo(order.paymentMethod).last4}
                          </span>
                        </span>
                      )}
                    </p>
                  )}

                  <div>
                    Order status:
                    {!loading && (
                      <span
                        className={
                          'order-status ' + order.orderStatus.toLowerCase()
                        }
                      >
                        <div>{order.orderStatus}</div>
                      </span>
                    )}
                  </div>
                  <br />

                  <table className=' orders-table'>
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th className='hide-col'>Price</th>
                        <th>Quantity</th>
                        <th>Total</th>
                      </tr>
                    </thead>

                    {loading ? null : (
                      <tbody>
                        {cartItems.map((o) => (
                          <tr key={inc++}>
                            <td>
                              <div className='item-pic'>
                                <img
                                  src={o.product.imageUrl}
                                  style={{
                                    marginRight: '10px',
                                  }}
                                  alt='pic'
                                />
                                <span className='hide-col'>
                                  {o.product.label}
                                </span>
                              </div>
                            </td>

                            <td className='hide-col'>{o.product.price}</td>

                            <td>{o.quantity}</td>

                            <td>
                              PKR <b>{o.product.price * o.quantity}</b>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </table>

                  {loading ? null : (
                    <>
                      <br />

                      <div className='checkout-subtotal'>
                        <h5>Sub total</h5>
                        <h3>
                          <span>PKR</span> {this.calculateTotal(cartItems)}
                        </h3>
                      </div>

                      {/* <div className='checkout-subtotal'>
                        <h5>Shipping</h5>
                        <h3>
                          <span>PKR</span> 0
                        </h3>
                      </div> */}

                      <div className='linee'></div>

                      <div className='checkout-total'>
                        <h5>Total</h5>
                        <h3>
                          <span>PKR</span> {this.calculateTotal(cartItems)}
                        </h3>
                      </div>
                    </>
                  )}

                  {currentUser.isAdmin && (
                    <>
                      <div className='linee'></div>
                      <br />
                      <Select
                        options={[
                          'Placed',
                          'Approved',
                          'Delivered',
                          'Recieved',
                          'Cancelled',
                        ]}
                        name='orderStatus'
                        value={order.orderStatus}
                        label='Update order Status'
                        onChange={this.handleChange}
                      />
                      <button
                        className='continue-to-shipping'
                        onClick={() => this.updateOrder('')}
                      >
                        Update order status
                      </button>
                    </>
                  )}

                  {order.orderStatus === 'Placed' && !currentUser.isAdmin && (
                    <>
                      <button
                        className='continue-to-shipping'
                        onClick={this.handleCancelPopUp}
                      >
                        Cancel order
                      </button>
                    </>
                  )}
                </div>

                <div className='col-md-4 p-2 '>
                  <div
                    className='profile-right-block dashboard-left-block'
                    style={{ animationDelay: '0.3s' }}
                  >
                    <br />
                    <div
                      className='dashboard-pic-circle'
                      style={{
                        backgroundImage: 'url(' + user.profilePic + ')',
                      }}
                    ></div>

                    <div className='profile-left-text'>
                      <h2>{user.name} (Buyer)</h2>
                      <a href={'tel:' + user.phone}>
                        <button>Call</button>
                      </a>
                      <a href={'mailto:' + user.email}>
                        <button style={{ marginTop: '-7px' }}>Email</button>
                      </a>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }

  calculateTotal = (cartItems) => {
    let total = 0;

    for (const c of cartItems) total = total + c.product.price * c.quantity;

    return total;
  };

  cardInfo = (payMethod) => {
    const fields = payMethod.split(' + ');

    const type = this.capitalizeFirstLetter(fields[0]);
    const last4 = fields[3];

    let img = '/img/visa.png';
    if (fields[2] === 'mastercard') img = '/img/master.png';

    return { type, img, last4 };
  };

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
}

export default OrderPage;
